export default class Helpers {

	static deepClone(obj) {
		return JSON.parse(JSON.stringify(obj));
	}
}
